import React, { DetailedHTMLProps, AnchorHTMLAttributes } from 'react';

export const CustomPlusIcon = ({
  colorsWontFitCount,
  htmlProps,
}: {
  colorsWontFitCount: number;
  htmlProps: DetailedHTMLProps<AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>;
}) => {
  return (
    <a {...htmlProps}>
      <label className="ps-have-more">
        <span className="alo-add-thick-icon icon__increment"></span>
        {colorsWontFitCount}
      </label>
    </a>
  );
};

// -- replace, 'stolen' from Nike; before sure to delete the related css
export const LoadingMoreSpinner = ({ isVisible = true, className = '' }) => {
  return (
    <div className={`LoadingMoreSpinner ${className}`}>
      <div className={`loader-overlay ${isVisible ? 'is--visible' : ''} css-4nxgc2`}>
        <div className="spinner" />
      </div>
    </div>
  );
};
